const EmptyState = ({ title, message }) => (
  <div className="status-card">
    <h3>{title}</h3>
    <p>{message}</p>
  </div>
);

export default EmptyState;
